import { useEffect, useRef } from 'react';
import './CorporateSponsorship.css';
import Navigation from './Navigation';
import Footer from './Footer';
import boatImage from '../assets/boat.png';

const CorporateSponsorship = () => {
  const ourPurposeVideo = 'https://assets.bluestar-rowing.com/assets/sponsor_video_web.mp4';
  const baseEmail = 'info@bluestar-rowing.com';
  const purposeVideoRef = useRef(null);

  useEffect(() => {
    const video = purposeVideoRef.current;
    if (!video) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.muted = false;
          video.play().catch(() => {
            // Ignore autoplay interruptions from browser policies.
          });
        } else {
          video.pause();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(video);

    return () => {
      observer.unobserve(video);
      observer.disconnect();
    };
  }, []);

  const packageEmailLink = (tier) =>
    `mailto:${baseEmail}?subject=${encodeURIComponent(`Corporate Sponsorship - ${tier}`)}`;

  return (
    <>
      <Navigation />
      <section className="section-seamless corporate-sponsorship-section">
         <div className="corporate-sponsorship-packages">
              <h2 className="packages-title">OFFICIAL PARTNERS</h2>

              <div className="packages-grid">
                <a className="package-card explorer" href={packageEmailLink('Explorer')}>
                  <div className="package-header">
                    <h3 className="package-tier">EXPLORER</h3>
                    <div className="package-price">£5k <span>(+ VAT)</span></div>
                  </div>
                  <ul className="package-benefits">
                    <li>Logo on hull (small)</li>
                    <li>Logo on website</li>
                    <li>Social media announcement post (our account had 250k views in the last 30 days)</li>
                    <li>Access to race photography</li>
                    <li>Logo on recognition board at Gym Possible new centre</li>
                  </ul>
                </a>

                <a className="package-card navigator" href={packageEmailLink('Navigator')}>
                  <div className="package-header">
                    <h3 className="package-tier">NAVIGATOR</h3>
                    <div className="package-price">£10k <span>(+ VAT)</span></div>
                  </div>
                  <div className="package-includes">Includes all Explorer Partner benefits, plus:</div>
                  <ul className="package-benefits">
                    <li>Logo on hull (medium)</li>
                    <li>Logo on website homepage</li>
                    <li>1x dedicated social media post/endorsement</li>
                    <li>Live updates during crossing</li>
                    <li>On-water training day with Blue Star Rowing</li>
                    <li>Branded apparel (back)</li>
                  </ul>
                </a>

                <a className="package-card pioneer" href={packageEmailLink('Pioneer')}>
                  <div className="package-header">
                    <h3 className="package-tier">PIONEER</h3>
                    <div className="package-price">£20k <span>(+ VAT)</span></div>
                  </div>
                  <div className="package-includes">Includes all Navigator Partner benefits, plus:</div>
                  <ul className="package-benefits">
                    <li>Logo on hull (large)</li>
                    <li>2x dedicated social media posts/endorsements</li>
                    <li>Pre- and post-row company talks</li>
                    <li>Branded apparel (front and sleeve)</li>
                  </ul>
                </a>
              </div>

              <div className="boat-image-container">
                <img
                  src={boatImage}
                  alt="Boat with sponsorship tiers"
                  className="boat-sponsorship-image"
                />
              </div>
            </div>
        <div className="corporate-sponsorship-hero">
          <div className="corporate-sponsorship-content">
            <div className="corporate-sponsorship-intro">
              <h2 className="corporate-sponsorship-subtitle">Why Partner with Us?</h2>
            </div>
            <div className="corporate-sponsorship-purpose-video-wrap">
              <video
                ref={purposeVideoRef}
                className="corporate-sponsorship-purpose-video"
                controls
                preload="metadata"
                playsInline
              >
                <source src={ourPurposeVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="corporate-sponsorship-benefits">
              <div className="benefit-card">
                <div className="benefit-number">1</div>
                <div className="benefit-content">
                  <h3 className="benefit-title">Unmatched Brand Exposure</h3>
                  <p className="benefit-description">
                    Your logo will travel across the Atlantic. Sponsorship brings your brand into media coverage,
                    social campaigns, events, and across our boat, kit, and digital platforms.
                  </p>
                </div>
              </div>

              <div className="benefit-card">
                <div className="benefit-number">2</div>
                <div className="benefit-content">
                  <h3 className="benefit-title">Inspire Your People</h3>
                  <p className="benefit-description">
                    This is a story of teamwork, and resilience - values that every business aspires to.
                    We offer opportunities for team talks, engagement events, and content that motivates your workforce.
                  </p>
                </div>
              </div>

              <div className="benefit-card">
                <div className="benefit-number">3</div>
                <div className="benefit-content">
                  <h3 className="benefit-title">Make an Impact</h3>
                  <p className="benefit-description">
                    Your support directly contributes to one of the world's most challenging endurance events.
                    Partner with us to demonstrate your commitment to excellence, determination, and pushing
                    boundaries - values that resonate with customers and stakeholders alike.
                  </p>
                </div>
              </div>
              <div className="corporate-sponsorship-cta">
              <p className="cta-text">Ready to partner with us?</p>
              <a
                href="mailto:info@bluestar-rowing.com "
                className="corporate-contact-button"
              >
                Contact Us
              </a>
            </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CorporateSponsorship;
